import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FormSectionProps {
  title: string;
  icon: React.ReactNode;
  iconBg: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function FormSection({
  title,
  icon,
  iconBg,
  children,
  defaultOpen = true
}: FormSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <section className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-97" data-mp="3oghbl874lx19">
      <header className="flex items-center justify-between border-b border-slate-200 bg-white px-4 py-3" data-id="element-98" data-mp="3tg3k54c0ep3q">
        <div className="flex items-center gap-2.5" data-id="element-99" data-mp="691k8y4dcohz">
          <span className="flex h-7 w-7 items-center justify-center rounded text-white" style={{
          backgroundColor: iconBg
        }} data-id="element-100" data-mp="6acmuum2vq7i">
            {icon}
          </span>
          <h2 className="text-[15px] font-semibold text-slate-800" data-id="element-101" data-mp="281ppte4hjo0x">{title}</h2>
        </div>
        <button type="button" onClick={() => setOpen(o => !o)} className="flex h-7 w-7 items-center justify-center rounded border border-slate-200 text-slate-500 transition-colors hover:bg-slate-100" aria-expanded={open} aria-label={open ? `Collapse ${title}` : `Expand ${title}`} data-id="element-102" data-mp="2d0k6oaiw72ie">
          <ChevronDownIcon className={`h-4 w-4 transition-transform ${open ? '' : '-rotate-90'}`} data-id="element-103" data-mp="26y9w2djvxzuk" />
        </button>
      </header>
      {open && <div className="px-2 pb-2 pt-0 sm:px-3" data-id="element-104" data-mp="2zpjtkm2gzswo">{children}</div>}
    </section>;
}
export function SubGroup({
  label,
  children
}: {
  label: string;
  children: React.ReactNode;
}) {
  return <div className="pt-3" data-id="element-105" data-mp="2qo3uvbl0pf8a">
      <h3 className="px-3 pb-1 text-[11px] font-semibold uppercase tracking-wide text-slate-400" data-id="element-106" data-mp="2qnakm0muo7le">{label}</h3>
      {children}
    </div>;
}